/* eslint-disable */

import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const moduleSpeech = {
  state: () => ({
    api: undefined,
    get: {
      SBlockTypes: false,
      UserSpeeches: false,
      ActiveSpeech: false
    },
    __SBlockTypes: [],
    __UserSpeeches: [],
    __ActiveSpeech: undefined
  }),
  getters: {
    /***
     * signal about loading of types of speech blocks
     * @return { Boolean } if types loaded - true, else - false
     */
    loadedSBlockTypes: (state) => {
      return state.get.SBlockTypes
    },
    /***
     * getter of types of speech blocks
     * @return { Array } types of speech blocks
     */
    SBlockTypes: (state) => {
      return state.__SBlockTypes
    },
    /***
     * signal about loading of user's speeches
     * @return { Boolean } if speeches loaded - true, else - false
     */
    loadedUserSpeech: (state) => {
      return state.get.UserSpeeches
    },
    /***
     * getter of user's speeches
     * @return { Array } user's speeches
     */
    UserSpeeches: (state) => {
      return state.__UserSpeeches
    },
    /***
     * signal about selected of active speech
     * @return { Boolean } if speech selected - true, else - false
     */
    selectActiveSpeech: (state) => {
      return state.get.ActiveSpeech
    },
    /***
     * getter of selected of active speech
     * @return { Object } active speech
     */
    ActiveSpeech: (state) => {
      return state.__ActiveSpeech
    }
  },
  mutations: {
    setSBlockTypes (state, { sbt }) {
      state.__SBlockTypes = sbt
      state.get.SBlockTypes = true
    },
    initialSpeech (state, { token }) {
      state.api = axios.create({
        baseURL: 'https://speechassessmentapp.herokuapp.com',
        headers: {
          'Authorization': token
        }
      })
    },
    addNewSpeech (state, { speech }) {
      console.log('Speech -> addNewSpeech')
    },
    deleteSpeech (state, { id }) {
      console.log('Speech -> deleteSpeech')
    },
    setSpeech (state, { speeches }) {
      state.__UserSpeeches = speeches
      state.get.UserSpeeches = true
    },
    selectedActiveSpeech (state, { activeSpeech }) {
      if (activeSpeech.speech === null) {
        activeSpeech.speech = []
      }
      state.__ActiveSpeech = activeSpeech
      state.get.ActiveSpeech = true
    },
    updateActiveSpeech (state, { metaSpeech, speech }) {
      state.__ActiveSpeech.name = metaSpeech.name
      state.__ActiveSpeech.description = metaSpeech.description
      state.__ActiveSpeech.created_at = metaSpeech.created_at
      state.__ActiveSpeech.updated_at = metaSpeech.updated_at
      state.__ActiveSpeech.speech = speech
    },
    deleteActiveSpeech (state) {
      state.get.ActiveSpeech = false
      const activeSpeechId = state.__ActiveSpeech.id
      const activeSpeechIndex = state.__UserSpeeches.findIndex(item => item.id === activeSpeechId)
      state.__ActiveSpeech = undefined
      state.__UserSpeeches.splice(activeSpeechIndex, 1)
    }
  },
  actions: {
    async getSBlockType ({ state, commit }) {
      try {
        const sbt = (await state.api.get('speech-blocks/')).data
        commit('setSBlockTypes', {
          sbt: sbt
        })
      } catch (e) {
        console.log('getSBlockType error')
      }
    },
    async getSpeeches ({ state, commit }) {
      try {
        const speeches = (await state.api.get('/users-speeches')).data
        commit('setSpeech', {
          speeches: speeches
        })
      } catch (e) {
        console.log('getSpeeches error')
      }
    },
    initialSpeech ({ state, commit, dispatch, rootState }) {
      const token = rootState.auth.token
      commit({
        type: 'initialSpeech',
        token: token
      })
      dispatch({
        type: 'getSpeeches'
      })
    },
    async updateActiveSpeech({ state, commit } , { metaSpeech, speech }) {
      commit({
        type: 'updateActiveSpeech',
        metaSpeech: metaSpeech,
        speech: speech
      })
      await state.api.put('/users-speeches/' + state.__ActiveSpeech.id, state.__ActiveSpeech)
    },
    async deleteActiveSpeech({ state, commit }) {
      await state.api.delete('/users-speeches/' + state.__ActiveSpeech.id)
      commit({
        type: 'deleteActiveSpeech'
      })
    },
    async addNewSpeech({ state, dispatch }){
      await state.api.post('/users-speeches', {})
      dispatch({
        type: 'getSpeeches'
      })
    }
  }
}

const moduleAuth = {
  state: () => ({
    api: undefined,
    token: localStorage.getItem('user-token') || '',
    status: '',
    speaker: undefined,
    get: {
      speaker: false
    }
  }),
  getters: {
    isAuthenticated: (state) => {
      return !!state.token
    },
    authStatus: (state) => {
      return state.status
    },
    speaker: (state) => {
      return state.speaker
    },
    loadedSpeaker: (state) => {
      return state.get.speaker
    }
  },
  mutations: {
    loginRequest (state) {
      state.status = 'load'
    },
    loginSuccess (state, { token }) {
      state.status = 'ok'
      state.token = token
    },
    setSpeaker (state, { speaker }) {
      state.speaker = speaker
      state.get.speaker = true
    },
    loginError (state) {
      state.status = 'error'
    },
    logoutRequest (state) {
      state.status = ''
      state.token = ''
      state.speaker = undefined
      state.get.speaker = false
    },
    loginInitial (state) {
      state.api = axios.create({
        baseURL: 'https://speechassessmentapp.herokuapp.com',
        headers: {
          'Authorization': state.token
        }
      })
    }
  },
  actions: {
    async loginRequest ({ state, commit }, { user }) {
      try {
        commit({
          type: 'loginRequest'
        })
        const auth = (await state.api.post('auth/local', {
          identifier: user.username,
          password: user.password
        })).data
        const newToken = 'Bearer ' + auth.jwt
        localStorage.setItem('user-token', newToken)
        commit({
          type: 'loginSuccess',
          token: newToken
        })
        commit({
          type: 'loginInitial'
        })
      } catch {
        commit({
          type: 'loginError'
        })
      }
    },
    async speakerRequest ({ state, commit }) {
      const speaker = (await state.api.get('speakers/me')).data
      commit({
        type: 'setSpeaker',
        speaker: speaker
      })
    },
    logoutRequest ({ commit }) {
      commit({
        type: 'logoutRequest'
      })
      localStorage.removeItem('user-token')
    }
  }
}

const moduleTribune = {
  state: () => ({
    api: undefined,
    __ActiveTribune: undefined,
    get: {
      ActiveTribune: false
    }
  }),
  getters: {
    ActiveTribune: (state) => {
      return state.__ActiveTribune
    },
    loadedActiveTribune: (state) => {
      return state.get.ActiveTribune
    }
  },
  mutations: {
    setActiveTribune (state, { tribune }) {
      state.__ActiveTribune = tribune
      state.get.ActiveTribune = true
    },
    initialTribune (state, { token }) {
      state.api = axios.create({
        baseURL: 'https://speechassessmentapp.herokuapp.com',
        headers: {
          'Authorization': token
        }
      })
    },
    leaveTribune (state) {
      state.__ActiveTribune = undefined
      state.get.ActiveTribune = false
    }
  },
  actions: {
    initialTribune ({ commit, rootState }) {
      const token = rootState.auth.token
      commit({
        type: 'initialTribune',
        token: token
      })
    },
    async addNewTribune ({ state, commit, dispatch }, { tribune }) {
      await state.api.post('/tribunes', tribune)
    },
    async getTribune ({ state, commit, dispatch }, { tribuneName }) {
      try {
        let tribune = (await state.api.get('/tribunes/' + tribuneName)).data
        commit({
          type: 'setActiveTribune',
          tribune: tribune
        })
      }
      catch (e) {
        throw e;
      }
    },
    async rateSpeech ({ state }, { rating }) {
      await state.api.post('/ratings', {
        tribune: state.__ActiveTribune.id,
        speaker: state.__ActiveTribune.speaker.id,
        comment: rating.comment,
        ...rating.rate
      })
    }
  }
}

const moduleContent = {
  state: () => ({
    __activeTopic: undefined
  }),
  getters: {
    activeTopic: (state) => {
      return state.__activeTopic.topic
    }
  },
  mutations: {
    seeTopic (state, topic) {
      state.__activeTopic = topic
    }
  },
  actions: {

  }
}

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    content: moduleContent,
    speech: moduleSpeech,
    auth: moduleAuth,
    tribune: moduleTribune
  }
})
